export default "__VITE_ASSET__CeLZ9GOz__"